module.exports = __webpack_public_path__ + "static/media/1_1.c36f5146.png";